import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  BUILDING_GROUP_FORM_FIELD_NAME_TITLE,
  BUILDING_GROUP_FORM_FIELD_TITLE_MAX_LENGTH,
} from '../../BuildingGroupForm.constants'

function TitleField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('BuildingGroup.TitleFieldLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={BUILDING_GROUP_FORM_FIELD_TITLE_MAX_LENGTH}
      name={BUILDING_GROUP_FORM_FIELD_NAME_TITLE}
      placeholder={t('BuildingGroup.TitleFieldPlaceholderKey')}
    />
  )
}

export default TitleField
